import React, { useState, useEffect } from "react";
import { SubscriptionsPopup } from "./SubscriptionsPopup.jsx";
import { Button } from "react-bootstrap";


export function Subscriptions({ configuration }) {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      const { hash } = window.location;
      if (hash == "#subscribe") setPopupOpen(true);
    }
  }, [firstLoad]);

  return (
    <>
      <div className="">
        <h4 className="h4">{configuration.translations.subscriptionsTitle}</h4>
        <p>{configuration.translations.subscriptionsDescr}</p>
        <Button
          variant="primary"
          onClick={() => { setPopupOpen(true); }}
        >
          {configuration.translations.subscribeButton}
        </Button>
        {isPopupOpen && (
          <SubscriptionsPopup
            show={isPopupOpen}
            onHide={() => setPopupOpen(false)}
            configuration={configuration}
          />
        )}
      </div>
    </>
  );
}
